import { render, staticRenderFns } from "./CustomWizardProgress.vue?vue&type=template&id=6e045032"
import script from "./CustomWizardProgress.vue?vue&type=script&lang=js"
export * from "./CustomWizardProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports